import { Button } from '@mui/material';
import { FC } from 'react';
import { InfoDial } from 'ui/InfoDial';
import { TInfoDialButtonProps } from './types';

export const InfoDialButton: FC<TInfoDialButtonProps> = ({ text, color = 'primary' }) => {
	return (
		<Button
			color="primary"
			sx={{
				p: 0,
				m: 0,
				ml: 0.5,
				idTransform: 'none',
				fontWeight: '900',
				fontFamily: 'monospace',
				minWidth: '17px',
				minHeight: '17px',
				textTransform: 'lowercase',
				borderRadius: '100%',
				backgroundColor: color === 'primary' ? 'transparent' : 'white',
				'&:hover': {
					backgroundColor: 'primary.light',
				},
			}}
		>
			<span
				style={{
					minWidth: '10px',
					minHeight: '10px',
					margin: '-4px -2px -5px -2px',
				}}
			>
				i
			</span>
			<InfoDial text={text} />
		</Button>
	);
};
